export default "__VITE_PUBLIC_ASSET__9866299d__"